/**
 * @generated SignedSource<<894855f62a6534973dfec95eec36635b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedVisuallySimilarItemsCarousel_viewer$data = {
  readonly visuallySimilarItems?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"PdpSharedProductTileCarousel_items">;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedProductTileCarousel_viewer">;
  readonly " $fragmentType": "PdpSharedVisuallySimilarItemsCarousel_viewer";
};
export type PdpSharedVisuallySimilarItemsCarousel_viewer$key = {
  readonly " $data"?: PdpSharedVisuallySimilarItemsCarousel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedVisuallySimilarItemsCarousel_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isArt"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": require('./PdpSharedVisuallySimilarItemsCarouselRefetchQuery.graphql')
    }
  },
  "name": "PdpSharedVisuallySimilarItemsCarousel_viewer",
  "selections": [
    {
      "condition": "isArt",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "visuallySimilarItems",
          "args": [
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "count"
            },
            {
              "kind": "Variable",
              "name": "itemPk",
              "variableName": "itemId"
            }
          ],
          "concreteType": "VisualSearchConnection",
          "kind": "LinkedField",
          "name": "visualSearch",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "VisualSearchEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Item",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "isTrade",
                          "variableName": "isTrade"
                        },
                        {
                          "kind": "Variable",
                          "name": "priceBookName",
                          "variableName": "priceBookName"
                        },
                        (v0/*: any*/)
                      ],
                      "kind": "FragmentSpread",
                      "name": "PdpSharedProductTileCarousel_items"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": [
        (v0/*: any*/)
      ],
      "kind": "FragmentSpread",
      "name": "PdpSharedProductTileCarousel_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "57ba06b77288b4ce3a7281c3a7e11839";

export default node;
